import { render, staticRenderFns } from "./Rentability.vue?vue&type=template&id=4f1f0818&"
import script from "./Rentability.vue?vue&type=script&lang=js&"
export * from "./Rentability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports